import React, { createContext, useContext, useReducer } from "react";

const ChatbotContext = createContext();

const initialState = {
  conversation: [
    {
      id: 1,
      text: "Hello! I'm your ESG assistant. Ask me anything about Environmental, Social, and Governance topics! 🌱",
      isUser: false,
      timestamp: new Date(),
    },
  ],
  isOpen: false,
  showOptions: false,
  activeChat: false,
  messageText: "",
  typingText: "",
  isTyping: false,
  isSending: false,
};

function chatbotReducer(state, action) {
  switch (action.type) {
    case "SET_CONVERSATION":
      return { ...state, conversation: action.payload };
    case "ADD_MESSAGE":
      return {
        ...state,
        conversation: [...state.conversation, action.payload],
      };
    case "SET_IS_OPEN":
      return { ...state, isOpen: action.payload };
    case "SET_SHOW_OPTIONS":
      return { ...state, showOptions: action.payload };
    case "SET_ACTIVE_CHAT":
      return { ...state, activeChat: action.payload };
    case "SET_MESSAGE_TEXT":
      return { ...state, messageText: action.payload };
    case "SET_TYPING_TEXT":
      return { ...state, typingText: action.payload };
    case "SET_IS_TYPING":
      return { ...state, isTyping: action.payload };
    case "SET_IS_SENDING":
      return { ...state, isSending: action.payload };
    case "CLEAR_TYPING_INTERVAL":
      if (action.payload) {
        clearInterval(action.payload);
      }
      return state;
    case "RESET_CHATBOT":
      return initialState;
    default:
      return state;
  }
}

export function ChatbotProvider({ children }) {
  const [state, dispatch] = useReducer(chatbotReducer, initialState);

  return (
    <ChatbotContext.Provider value={{ state, dispatch }}>
      {children}
    </ChatbotContext.Provider>
  );
}

export function useChatbot() {
  const context = useContext(ChatbotContext);
  if (!context) {
    throw new Error("useChatbot must be used within a ChatbotProvider");
  }
  return context;
}
